import React, { useContext } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Conversation from './components/Conversation'
import SelectMode from './components/SelectMode'
import MainContextProvider, { MainContext } from './MainContext'

function App() {
  const {
    mode,
    setMode,
    needToTrackFace,
    setNeedToTrackFace,
    isLoading
  } = useContext(MainContext)

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={SelectMode} />
          <Route exact path="/meet" component={Conversation} />
          <Route render={() => <div>not found</div>} />
        </Switch>
      </BrowserRouter>
    </div>
  )
}

const AppContainer: React.FC = () => {
  return (
    <MainContextProvider>
      <App />
    </MainContextProvider>
  )
}

export default AppContainer
